import { css } from "@emotion/core";
import emotionNormalize from 'emotion-normalize';

export default {
  colors: {
    light: '#FFFBEC',
    dark: '#002717',
    darkTransparent: 'rgba(0, 39, 23, 0.2)',
    darkTransparentStrong: 'rgba(0, 39, 23, 0.05)',
  },

  size: {
    xsmall: '7px',
    small: '14px',
    medium: '18px',
    large: '21px',
    xlarge: '32px',
  },

  breakpoint: {
    phone: '@media (min-width: 570px)',
    tablet: '@media (min-width: 768px)',
    desktop: '@media (min-width: 1200px)',
  }
};

export const globalStyles = css`
  // ${emotionNormalize}

  // Post-normalize resets
  //------------------------------------------------------------------------------
  // See https://github.com/suitcss/base/blob/master/lib/base.css
  //
  // 'A thin layer on top of normalize.css that provides a starting point more
  // suitable for web applications. Removes the default spacing and border for
  // appropriate elements.'

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  // Removes the default spacing and border for appropriate elements.
  blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  figure,
  p,
  pre {
    margin: 0;
  }

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    padding: 0;
    background: transparent;
    border: 0;
    border-radius: 0;
    text-align: inherit;
    appearance: none;
  }

  // Work around a Firefox/IE bug where the transparent button background
  // results in a loss of the default button focus styles.
  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }

  fieldset {
    border: 0;
    margin: 0;
    padding: 0;
  }

  iframe {
    border: 0;
  }

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    list-style: none;
  }

  // .is-mouse-focused is applied in focus-fix.coffee. This removes the focus outline when clicking
  // buttons, but keeps it visible when navigating with e.g. keyboard.
  :active,
  .is-mouse-focused:focus {
    outline: none;
  }

  * {
    font-family: 'Roboto Mono', monospace;
  }

  html {
    background-color: #fffbec;
  }`
